// ========================================
// COMPONENTS / Founders.jsx — Moon Berry
// ========================================

import React from "react";
import styles from "./Founders.module.css";

const FOUNDERS = [
  {
    name: "Kanchan Katara",
    role: "Co-Founder & CEO",
    photo: "/Kanchan Katara.jpg",
    bio: [
      "Kanchan Katara is a mother of two and has been based in Dubai for over 20 years, building a life shaped by resilience, dedication, and quiet ambition. With a long-held vision to create something of her own, she has grown through every challenge with strength and self-belief.",
      "Her journey reflects perseverance and purpose, transforming life experiences into motivation to build something meaningful. Moon Berry is the result of that vision — a brand created with heart, elegance, and intention, reflecting her belief in growth, creativity, and the beauty of everyday moments.",
    ],
    emoji: "🌸",
  },
  {
    name: "Aashima Mehta",
    role: "Co-Founder & CEO",
    photo: "/Aashima Mehta.jpg",
    bio: [
      "Aashima Mehta is a mother of two and has been based in Dubai for the past 10 years, building her journey with passion, creativity, and determination. With a strong entrepreneurial spirit and a love for thoughtful design, she has always believed in creating something meaningful that brings joy to everyday life.",
      "Her journey reflects dedication, growth, and the courage to turn ideas into reality. Inspired by creativity and modern lifestyle trends, she co-founded Moon Berry with the vision of offering products that are stylish, fun, and thoughtfully curated — creating a brand that celebrates happiness in the little things.",
    ],
    emoji: "✨",
  },
];

export default function Founders() {
  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <p className={styles.label}>The People Behind Moon Berry</p>
        <h2 className={styles.title}>Meet Our <span className={styles.brand}>Founders</span></h2>
        <div className={styles.divider} />
      </div>

      <div className={styles.cards}>
        {FOUNDERS.map((f) => (
          <div key={f.name} className={styles.card}>
            <div className={styles.photoWrap}>
              <img
                src={f.photo}
                alt={f.name}
                className={styles.photo}
                onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
              />
              <div className={styles.photoFallback} style={{ display: "none" }}>
                <span className={styles.fallbackEmoji}>{f.emoji}</span>
              </div>
            </div>
            <div className={styles.info}>
              <h3 className={styles.name}>{f.name}</h3>
              <p className={styles.role}>{f.role}</p>
              <div className={styles.bio}>
                {f.bio.map((para, i) => (
                  <p key={i}>{para}</p>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
